var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 54,
    viewBox: "0 0 50 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 29.9648C38.5614 29.9649 49.6557 40.5542 49.6562 53.7383H46.6562C46.6557 42.3198 37.0154 32.9649 25 32.9648C12.9847 32.965 3.3443 42.3199 3.34375 53.7383H0.34375C0.344298 40.5543 11.4386 29.965 25 29.9648ZM25 0.265625C31.741 0.265666 37.3056 5.53664 37.3057 12.1602C37.3057 18.7837 31.7411 24.0546 25 24.0547C18.259 24.0546 12.6934 18.7837 12.6934 12.1602C12.6934 5.53669 18.259 0.26575 25 0.265625ZM25 3.26562C19.805 3.26575 15.6934 7.30227 15.6934 12.1602C15.6934 17.0181 19.805 21.0546 25 21.0547C30.1951 21.0546 34.3057 17.0181 34.3057 12.1602C34.3056 7.30222 30.195 3.26567 25 3.26562Z",
    fill: "#617A85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPhoto);
export default __webpack_public_path__ + "static/media/userPhoto.d6252c6f245ce555e09e2363b97a305e.svg";
export { ForwardRef as ReactComponent };